import { render } from "./NewSetScript.vue?vue&type=template&id=b82afdde"
import script from "./NewSetScript.vue?vue&type=script&lang=js"
export * from "./NewSetScript.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__